import { render, staticRenderFns } from "./TarfBenList.vue?vue&type=template&id=70812a57&"
import script from "./TarfBenList.vue?vue&type=script&lang=js&"
export * from "./TarfBenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports